import { useViewport } from '@nuvolo/nuux-theme/hooks/useViewport';
import React from 'react';
import If from '#/common/components/If';
import AssetDataGrid from '../AssetDataGrid';
import AssetList from '../AssetList';

const Assets: React.FC = () => {
  const { isDesktop } = useViewport();

  return (
    <>
      <If condition={isDesktop}>
        <AssetDataGrid />
      </If>
      <If condition={!isDesktop}>
        <AssetList />
      </If>
    </>
  );
};

export default React.memo(Assets);
